export class GlobalState {
  public licensePlate: string = "";
  public scanDate?: string;
  public lat: number | null = null;
  public lon: number | null = null;

  public clear() {
    this.licensePlate = "";
    this.scanDate = undefined;
    this.lat = null;
    this.lon = null;
  }
}

export default new GlobalState();
